<template>
  <div class="cyg-wrap">
    <v-card
      class="cyg-card shadowCard"
      flat
      role="article"
      aria-labelledby="cyg-title"
      @click="abrirDialogo"
    >
      <div class="cyg-glow" aria-hidden="true"></div>
      <div class="cyg-inner">
        <div class="cyg-icon-wrap" aria-hidden="true">
          <v-icon color="white" class="cyg-icon">mdi-gift-outline</v-icon>
        </div>
        <div class="cyg-copy">
          <span class="cyg-overline">Recomendados</span>
          <h3 id="cyg-title" class="cyg-title">¡Comparte y gana!</h3>
          <p class="cyg-desc">
            Invita a un amigo a estudiar inglés y obtén beneficios por cada recomendado.
          </p>
          <div class="cyg-actions" @click.stop>
            <v-btn
              block
              rounded
              depressed
              class="cyg-btn-primary text-none font-weight-bold"
              aria-label="Compartir enlace de recomendados"
              @click="abrirDialogo"
            >
              <v-icon left size="18">mdi-share-variant</v-icon>
              Compartir
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>

    <ComparteGanaDialog
      v-if="alertaComparte.estatus"
      :alertaComparte="alertaComparte"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ComparteGanaDialog from '@/components/alertas/ComparteGana.vue'
  import { sesionReferralDesdeGetters } from '@/referrals/sesion'

  export default {
    components: {
      ComparteGanaDialog
    },

    data () {
      return {
        alertaComparte: {
          estatus: false,
        },
      }
    },

    computed: {
      ...mapGetters('login', [
        'getLogeadoLMS',
        'getUsuarioLMS',
        'getDatosUsuarioLMS',
        'getEscuela',
      ]),

      sesionReferral () {
        return sesionReferralDesdeGetters({
          logeado: this.getLogeadoLMS,
          usuario: this.getUsuarioLMS,
          datosUsuario: this.getDatosUsuarioLMS,
          escuela: this.getEscuela,
        })
      },
    },

    methods: {
      abrirDialogo () {
        if (!this.sesionReferral.ok) return
        this.alertaComparte.estatus = true
      },
    }
  }
</script>

<style scoped>
  .cyg-wrap {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .cyg-card {
    width: 100%;
    height: 100%;
    min-height: 200px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, #8b0000 0%, #db0212 48%, #ff4d4d 100%) !important;
    box-shadow:
      0 8px 18px -6px rgba(219, 2, 18, 0.35),
      0 18px 40px -12px rgba(139, 0, 0, 0.28) !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .cyg-card:hover {
    transform: translateY(-1px);
    box-shadow:
      0 12px 22px -6px rgba(219, 2, 18, 0.4),
      0 24px 48px -14px rgba(139, 0, 0, 0.32) !important;
  }

  .cyg-glow {
    position: absolute;
    width: min(180px, 55%);
    height: min(180px, 55%);
    right: -40px;
    top: -50px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(248, 218, 105, 0.35) 0%, rgba(248, 218, 105, 0) 70%);
    pointer-events: none;
  }

  .cyg-inner {
    position: relative;
    z-index: 1;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: clamp(16px, 3vw, 22px);
    min-height: 200px;
  }

  .cyg-icon-wrap {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.22);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);
  }

  .cyg-icon {
    font-size: 26px !important;
  }

  .cyg-copy {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    text-align: left;
    color: #fff;
  }

  .cyg-overline {
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(248, 218, 105, 0.95);
    margin-bottom: 4px;
  }

  .cyg-title {
    margin: 0 0 8px;
    font-size: clamp(1.15rem, 2.4vw, 1.35rem);
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: #fff;
  }

  .cyg-desc {
    margin: 0 0 16px;
    font-size: clamp(0.82rem, 1.8vw, 0.92rem);
    line-height: 1.45;
    color: rgba(255, 255, 255, 0.82);
  }

  .cyg-actions {
    margin-top: auto;
    width: 100%;
  }

  .cyg-btn-primary {
    background: rgba(255, 255, 255, 0.95) !important;
    color: #db0212 !important;
    letter-spacing: 0.01em;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 599px) {
    .cyg-inner {
      flex-direction: row;
      align-items: flex-start;
      min-height: 0;
    }

    .cyg-card {
      min-height: 0;
    }

    .cyg-copy {
      flex: 1;
    }
  }
</style>
